export default class ActiveUpload {
  constructor({
    id,
    fileListId,
    fileName,
    uploadCompleted,
    fileSize,
    url,
    folderName,
    folderId,
    status,
    statusReason,
    targetOrganisationId,
    uploadOrganisationId,
    canView,
    uploadUser,
    targetOrg,
    associatedFile,
    manualQaRequired,
    sewerData,
    standardKey,
    createdTime,
    updatedAt,
    timesRetried,
    retryableState,
    isRetryable,
    progress,
    file,
    clientId,
    controller,
    errorMsg,
    completedAt,
    cleanedName,
  }) {
    this.id = id;
    this.fileListId = fileListId;
    this.fileName = fileName;
    this.uploadCompleted = uploadCompleted;
    this.fileSize = fileSize;
    this.url = url;
    this.folderName = folderName;
    this.folderId = folderId;
    this.status = status;
    this.statusReason = statusReason;
    this.targetOrganisationId = targetOrganisationId;
    this.uploadOrganisationId = uploadOrganisationId;
    this.canView = canView;
    this.uploadUser = uploadUser;
    this.targetOrg = targetOrg;
    this.associatedFile = associatedFile;
    this.manualQaRequired = manualQaRequired;
    this.sewerData = sewerData;
    this.standardKey = standardKey;
    this.createdTime = new Date(createdTime);
    this.updatedAt = new Date(updatedAt);
    this.timesRetried = timesRetried;
    this.retryableState = retryableState;
    this.isRetryable = isRetryable;
    this.progress = progress;
    this.file = file;
    this.clientId = clientId;
    this.controller = controller;
    this.errorMsg = errorMsg;
    this.completedAt = completedAt;
    this.cleanedName = cleanedName;
  }

  static fromServerModel(data) {
    return new ActiveUpload({
      ...data,
      fileName: data.filename,
    });
  }
}
